<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div class="editor-dialog">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center py-2 px-0">
          <span class="primary--text">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
      </div>
      <v-card-text class="pa-4">
        <label class="label-input">Section Name</label>
        <v-row>
          <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name"/></v-col>
          <v-col cols="12" md="4"><v-checkbox v-model="fields.enableAnchor" label="Enable Anchor"/></v-col>
        </v-row>

        <label class="label-input">Image</label>
        <div class="group-item">
          <v-row>
            <v-col cols="12" md="6"><v-checkbox v-model="fields.image.show" label="Show image" hide-details/></v-col>
            <v-col cols="12" md="6"
              ><v-select v-model="fields.image.position" :items="positionOptions" label="Image position"
            /></v-col>
          </v-row>
          <div v-if="fields.image.show" class="mt-4">
            <UploadImage
              :image="{ imageSrc: fields.image.src }"
              :height="'240'"
              :typeUpload="'image'"
              @callback="handleUploadImage"
              @callbackDelete="handleRemoveImage"
            />
            <v-text-field v-model="fields.image.alt" class="mt-4" label="Image alt" hide-details />
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Content</label>
          <div class="group-item">
            <label class="d-block mb-2">Header</label>
            <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />

            <div class="d-flex justify-space-between align-center mt-6 mb-4">
              <label class="label-input mb-0">List items</label>
              <v-btn small color="primary" @click="handleAddItem"><v-icon size="16">mdi-plus</v-icon>Add Item</v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.listItem" :key="'upairy-card-' + index">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center flex-grow-1">
                    <span>{{ getItemLabel(item.title, index) }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)"
                      ><v-icon color="#ff6c6c">mdi-delete</v-icon></v-btn
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <label class="d-block mb-2">Title</label>
                  <ckeditor :editor="editor" v-model="item.title" :config="editorConfig" />
                  <label class="d-block mt-4 mb-2">Description</label>
                  <ckeditor :editor="editor" v-model="item.description" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mt-6">
          <ButtonPrimary :button="fields.button" :showIconPrefix="false" :showIconSuffix="false" :showSubBtn="false" />
        </div>

        <div class="mt-6">
          <label class="label-input">Footer</label>
          <ckeditor :editor="editor" v-model="fields.footer" :config="editorConfig" />
        </div>

        <SectionSettingsContainerFuild
          class="mt-6"
          :settings="fields.settings"
          :containerPage="fields.containerPage"
          :showBackgroundImage="false"
          :showContainerPage="false"
        />
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions class="py-2 px-0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultImage = 'https://cdn.skyfastimg.com/images/2026/08/06/image-6a74036a3db831797c4c6406.webp?w=1000';

const defaultItem = () => ({
  title: `<h2><span style="color:hsl( 110, 39%, 41% );"><strong>Title</strong></span></h2>`,
  description: '<p>Description</p>',
});

const defaultButton = {
  show: true,
  backgroundColor: '#4B963E',
  color: '#FFFFFF',
  radius: 16,
  text: '👉 START POTTY TRAINING TODAY',
  link: '#',
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
};

export default {
  name: 'UpairyCard',
  components: { UploadImage, ButtonPrimary, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
      fields: {
        title: 'Upairy card',
        enableAnchor: false,
        image: { show: true, position: 'left', src: defaultImage, alt: 'Child wearing UpAiry training underwear' },
        header: '',
        listItem: [],
        button: { ...defaultButton },
        footer: '',
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
      },
    };
  },
  mounted() {
    const extract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...this.fields,
      ...extract,
      image: { ...this.fields.image, ...(extract.image || {}) },
      button: { ...defaultButton, ...(extract.button || {}) },
      settings: { ...this.fields.settings, ...(extract.settings || {}) },
      containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
      listItem: (extract.listItem || []).map(item => ({ ...defaultItem(), ...item })),
    };
  },
  methods: {
    handleAddItem() {
      this.fields.listItem.push(defaultItem());
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadImage(obj) {
      this.fields.image.src = obj?.imageSrc || '';
    },
    handleRemoveImage() {
      this.fields.image.src = '';
    },
    getItemLabel(value, index) {
      return (
        String(value || '')
          .replace(/<[^>]*>/g, '')
          .trim() || `Item ${index + 1}`
      );
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionUpairyCard(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-dialog {
  background-color: #fff;
}
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px;
  font-weight: 500;
}
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.header-modal,
.footer-modal {
  position: sticky;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.header-modal {
  top: 0;
}
.footer-modal {
  bottom: 0;
}
</style>
